/**
 * Property marketing (iframe) translations.
 *
 * Powers the standalone `/iframe/properties/:propertyId/marketing` page,
 * intended to be embedded in a Building Stack modal for editing a property's
 * marketing-facing configuration (property type, unit count, status).
 */

export const propertyMarketingEn = {
  propertyMarketing: {
    sections: {
      propertyType: 'Property Type',
      marketingStatus: 'Building Marketing Status',
    },
    fields: {
      marketingStatus: 'Building marketing status',
      unitCount: 'Total # of units in building',
    },
    helper: {
      marketingEnable: 'This setting will allow your property to be listed on connected websites and listing sites.',
      statusDisabledPromoted: 'This property has an active promoted listing. Please manage the promoted listing before updating the property status.',
    },
    banners: {
      singleUnitRestriction: 'Single-unit properties are limited to {count} unit(s). Choose a multi-unit type to add more.',
    },
    propertyType: {
      label: 'Property Type',
      categoryLabel: 'Property Category',
      howManyUnits: 'How Many Units?',
      categories: {
        residential: 'Residential',
        commercial: 'Commercial',
        recreational: 'Recreational',
        other: 'Other',
      },
      unitTypes: {
        multiUnit: 'Multi-unit',
        singleUnit: 'Single-unit',
      },
      condoBuildingType: 'Condo Building Type',
      luxuryApartment: 'Luxury Apartment',
      totalUnitsCondoBuilding: 'Total Units in Condo Building',
      condoOptions: {
        select: 'Select',
        highRise: 'High-Rise',
        midRise: 'Mid-Rise',
        lowRise: 'Low-Rise',
      },
    },
    statusOptions: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      hidden: 'Hidden',
    },
  },
} as const;

export const propertyMarketingFr = {
  propertyMarketing: {
    sections: {
      propertyType: 'Type de propriété',
      marketingStatus: 'Statut de marketing de l’immeuble',
    },
    fields: {
      marketingStatus: 'Statut de marketing de l’immeuble',
      unitCount: 'Nombre total d’unités dans l’immeuble',
    },
    helper: {
      marketingEnable: 'Ce paramètre permettra à votre propriété d’être publiée sur les sites Web connectés et les sites d’annonces.',
      statusDisabledPromoted: 'Cette propriété possède une annonce promue active. Veuillez gérer l’annonce promue avant de modifier le statut de la propriété.',
    },
    banners: {
      singleUnitRestriction: 'Les propriétés à unité unique sont limitées à {count} unité(s). Choisissez un type multi-unités pour en ajouter davantage.',
    },
    propertyType: {
      label: 'Type de propriété',
      categoryLabel: 'Catégorie de propriété',
      howManyUnits: 'Combien d’unités ?',
      categories: {
        residential: 'Résidentiel',
        commercial: 'Commercial',
        recreational: 'Récréatif',
        other: 'Autre',
      },
      unitTypes: {
        multiUnit: 'Multi-unités',
        singleUnit: 'Unité unique',
      },
      condoBuildingType: 'Type d’immeuble en copropriété',
      luxuryApartment: 'Appartement de luxe',
      totalUnitsCondoBuilding: 'Nombre total d’unités dans l’immeuble en copropriété',
      condoOptions: {
        select: 'Sélectionner',
        highRise: 'Tour de grande hauteur',
        midRise: 'Tour de hauteur moyenne',
        lowRise: 'Immeuble de faible hauteur',
      },
    },
    statusOptions: {
      enabled: 'Activé',
      disabled: 'Désactivé',
      hidden: 'Masqué',
    },
  },
} as const;
